import { PAGES } from '@ats/constants';
import ErrorLayout from '@layout/Error';
import NotFoundPage from 'client/src/pages/NotFound';
import type { RouteObject } from 'react-router';

const NotFoundRoute: RouteObject = {
  path: PAGES.ALL,
  element: <ErrorLayout />,
  children: [
    {
      path: PAGES.ALL,
      element: <NotFoundPage />,
    },
  ],
};

export default NotFoundRoute;
